import React from 'react';
import {
  FaUserTie,
  FaBuilding,
  FaHandsHelping,
  FaTrophy,
  FaBriefcase,
} from 'react-icons/fa';
import './styles.css';

const features = [
  {
    icon: <FaUserTie />,
    title: 'Pengajar Profesional',
    text: 'Didukung oleh guru-guru berpengalaman dan bersertifikat di bidang pariwisata & perhotelan.',
    color: '#6B0315',
    bgLight: 'rgba(107, 3, 21, 0.09)',
  },
  {
    icon: <FaBuilding />,
    title: 'Fasilitas Modern',
    text: 'Lab praktik hotel, dapur training, ruang kelas ber-AC, dan perpustakaan lengkap.',
    color: '#1565C0',
    bgLight: 'rgba(21, 101, 192, 0.09)',
  },
  {
    icon: <FaHandsHelping />,
    title: 'Kerjasama Industri',
    text: 'Jaringan luas dengan hotel berbintang dan biro perjalanan ternama untuk program magang.',
    color: '#2E7D32',
    bgLight: 'rgba(46, 125, 50, 0.09)',
  },
  {
    icon: <FaTrophy />,
    title: 'Prestasi Gemilang',
    text: 'Siswa kami aktif mengikuti perlombaan dan meraih prestasi di tingkat kota, provinsi, hingga nasional setiap tahunnya.',
    color: '#E65100',
    bgLight: 'rgba(230, 81, 0, 0.09)',
  },
  {
    icon: <FaBriefcase />,
    title: 'Siap Kerja',
    text: 'Kurikulum berbasis industri yang memastikan lulusan langsung siap memasuki dunia kerja.',
    color: '#6A1B9A',
    bgLight: 'rgba(106, 27, 154, 0.09)',
  },
];

const WhyChooseUs = () => {
  return (
    <section className="section why-choose-us-section">
      <div className="container">
        <div className="why-section-header">
          <span className="why-section-label">Keunggulan Kami</span>
          <h2 style={{ color: 'inherit' }}>
            Mengapa Memilih{' '}
            <span className="why-highlight">SMK Pariwisata Sumbangsih?</span>
          </h2>
          <p className="why-section-desc">
            Kami berkomitmen mencetak lulusan profesional yang kompeten, berkarakter,
            dan siap bersaing di industri pariwisata global.
          </p>
        </div>
        <div className="why-features-grid">
          {features.map((feature, index) => (
            <div
              key={index}
              className="why-feature-card"
              style={{
                '--card-color': feature.color,
                '--card-bg': feature.bgLight,
                animationDelay: `${index * 0.1}s`,
              }}
            >
              <div className="why-feature-number">{String(index + 1).padStart(2, '0')}</div>
              <div
                className="why-feature-icon"
                style={{ background: feature.bgLight, color: feature.color }}
              >
                {feature.icon}
              </div>
              <h3 className="why-feature-title">{feature.title}</h3>
              <p className="why-feature-text">{feature.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};


export default WhyChooseUs;